export default __webpack_public_path__ + "static/media/jbc.b5ab9868.svg";